<div class="d-flex">
	<div class="m-2">
		<span *ngIf="items && items.length > 0">Most frequently orders {{ items[0].name }}</span>
		<span *ngIf="visitDays"> visits most often on {{ moment().day(this.visitDays[0].day).format("dddd") }}</span>
	</div>
</div>
<div class="d-flex flex-wrap">
	<div class="d-flex card flex-fill flex-column h-100 mx-2">
		<div class="m-2 d-flex">
			{{ app.references.toTitleCase(customerService.customer.value.firstName) }} {{ app.references.toTitleCase(customerService.customer.value.lastName) }}
		</div>
		<div class="m-2">
			<span *ngIf="customerService.customer.value.email !== 'undefined'">{{ customerService.customer.value.email?.toLowerCase() }}</span>
		</div>
		<div class="p-grid">
			<div class="p-col-12 p-md-3">Phone Numbers</div>
			<div class="p-col-12 p-md-9">
				<div *ngFor="let phone of customerService.customer.value.phone" class="ms-4 mb-2">
					{{ app.references.phoneNumberToDisplayFormat(phone) }}
				</div>
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col-12 p-md-3">Addresses</div>
			<div class="p-col-12 p-md-9">
				<div *ngFor="let rec of customerService.customer.value.addresses" class="d-flex ms-4 mb-4 flex-column">
					<div>{{ rec.street1 }}</div>
					<div>{{ rec.city }} {{ rec.state }}, {{ rec.postalCode }}</div>
					<div>Last order: {{ moment(rec.lastUseDateTime).format("l") }}</div>
				</div>
			</div>
		</div>
	</div>
	<div class="d-flex card flex-fill flex-column h-100 mx-2">
		<div class="m-2 text-uppercase">visits: {{ customerService.customer.value.visitCount }}</div>
		<div class="m-2 text-uppercase">revenue: {{ customerService.customer.value.totalRevenue | currency }}</div>
		<div class="m-2 text-uppercase">first visit: {{ moment(customerService.customer.value.firstVisitDate).format("l") }}</div>
		<div class="m-2 text-uppercase">last visit: {{ moment(customerService.customer.value.lastVisitDate).format("l") }}</div>
	</div>
</div>
<div class="d-flex">
	<div class="d-flex card flex-fill flex-column my-2">
		<div class="d-flex p-fluid">
			<span class="p-float-label p-fluid w-100">
				<p-chips
					[(ngModel)]="customerTags"
					class="p-fluid w-100"
					id="customerService.customer.valueTags"
					(onAdd)="tagAdd($event)"
					allowDuplicate="false"
					addOnTab="true"
					addOnBlur="true"
					name="customerService.customer.valueTags"
				></p-chips>
				<label for="customerService.customer.valueTags">Tags</label>
			</span>
		</div>
		<div class="d-flex flex-row m-3 overflow-scroll">
			<div *ngFor="let rec of customerService.customer.value.tags">
				<p-chip label="{{ rec }}" styleClass="mx-2 custom-chip" [removable]="true" (onRemove)="customerService.save()"></p-chip>
			</div>
		</div>
	</div>
</div>
